module.exports = "https://cdn.realtymogul.com/static/media/img_returnsMRII.af58f739.png";